import { render, staticRenderFns } from "./ReferenceFileWidget.vue?vue&type=template&id=88e0217c&scoped=true&"
import script from "./ReferenceFileWidget.vue?vue&type=script&lang=js&"
export * from "./ReferenceFileWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFileWidget.vue?vue&type=style&index=0&id=88e0217c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e0217c",
  null
  
)

export default component.exports